import React, { memo } from 'react'
import { number, string } from 'prop-types'

export const ClipBoard = memo(({ height = 51, primaryColor = '#6AABB8', secondaryColor = '#FFA06A', width = 40 }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 40 51"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g
					id="2---MBP-CatPg-"
					transform="translate(-1034.000000, -2446.000000)"
					fillRule="nonzero"
					strokeWidth="0.5"
				>
					<g id="Section-3---How-we-Decided" transform="translate(360.000000, 2360.000000)">
						<g id="How-we-Decided">
							<g id="Section-3---How-we-Decided">
								<g id="Stat-2" transform="translate(649.000000, 74.000000)">
									<g id="ic_researched" transform="translate(26.000000, 13.000000)">
										<g>
											<path
												d="M33.72216,6.38847782 L29.2727278,6.38847782 L29.2727278,4.41503519 C29.2727278,3.77655212 28.5702272,3.48636284 27.9262215,3.48636284 L24.4721013,3.48636284 C23.6524985,1.16462642 21.6033796,0.00375821003 19.2615614,0.00375821003 C16.9455168,-0.0825653233 14.8389113,1.32538595 14.0510214,3.48636284 L10.6553962,3.48636284 C10.0113906,3.48636284 9.36738496,3.77655212 9.36738496,4.41503519 L9.36738496,6.38847782 L4.91784068,6.38847782 C2.28108201,6.41636355 0.123937743,8.47857388 0,11.0899441 L0,44.3487239 C0,46.9026562 2.34181822,48.7600009 4.91784068,48.7600009 L33.72216,48.7600009 C36.2981825,48.7600009 38.6400007,46.9026562 38.6400007,44.3487239 L38.6400007,11.0900552 C38.516063,8.47857388 36.3589187,6.41636355 33.72216,6.38847782 Z M11.7090911,5.80809927 L14.9291192,5.80809927 C15.4912094,5.74010699 15.9426968,5.31615511 16.0415333,4.76332899 C16.3882452,3.26638782 17.7128999,2.19184314 19.2615614,2.15140329 C20.7958792,2.19750916 22.1005873,3.27538679 22.4229823,4.76332899 C22.527982,5.33526406 23.0092773,5.76465975 23.5938914,5.80809927 L26.9310216,5.80809927 L26.9310216,10.4515721 L11.7090911,10.4515721 L11.7090911,5.80809927 Z M36.2981825,44.348835 C36.2981825,45.6258011 35.0101712,46.4383756 33.72216,46.4383756 L4.91784068,46.4383756 C3.62982945,46.4383756 2.34181822,45.6258011 2.34181822,44.348835 L2.34181822,11.0900552 C2.46127359,9.76087275 3.57200678,8.73465591 4.91784068,8.71021424 L9.3672729,8.71021424 L9.3672729,11.6705448 C9.42912971,12.3209154 9.99727108,12.8074158 10.6552841,12.7734196 L27.9261095,12.7734196 C28.596225,12.8097488 29.1821838,12.3299144 29.2726157,11.6705448 L29.2726157,8.71021424 L33.722048,8.71021424 C35.0677698,8.73465591 36.1786151,9.76076165 36.2981825,11.0899441 L36.2981825,44.348835 L36.2981825,44.348835 Z"
												id="Shape"
												stroke={primaryColor}
												fill={primaryColor}
											></path>
											<path
												d="M14.3639819,26.1114781 C13.9298487,25.6657619 13.2091367,25.6406222 12.7434322,26.0551567 L9.03939778,29.4936779 L7.47678421,27.9152748 C7.04265104,27.4695586 6.32193901,27.4445268 5.85623453,27.8589534 C5.40792196,28.3164303 5.40792196,29.036201 5.85623453,29.4936779 L8.22906755,31.8612285 C8.43444721,32.0852195 8.73110673,32.2090835 9.039287,32.1994808 C9.34458709,32.1952729 9.63581855,32.0736747 9.84950646,31.8612285 L14.3637603,27.6898812 C14.8112975,27.2900205 14.8412071,26.6124369 14.4305586,26.176647 C14.4095111,26.1538811 14.387245,26.1321941 14.3639819,26.1114781 Z"
												id="Path"
												stroke={secondaryColor}
												fill={secondaryColor}
											></path>
											<path
												d="M31.961478,28.5200005 L18.638523,28.5200005 C17.998669,28.5200005 17.4800003,29.1378242 17.4800003,29.9000005 C17.4800003,30.6621768 17.998669,31.2800006 18.638523,31.2800006 L31.961478,31.2800006 C32.6013319,31.2800006 33.1200006,30.6621768 33.1200006,29.9000005 C33.1200006,29.1378242 32.6013319,28.5200005 31.961478,28.5200005 Z"
												id="Path"
												stroke={primaryColor}
												fill={primaryColor}
											></path>
											<path
												d="M14.3639819,16.911478 C13.9298487,16.4657617 13.2091367,16.4406221 12.7434322,16.8551565 L9.03939778,20.2936777 L7.47678421,18.7152747 C7.04265104,18.2695584 6.32193901,18.2444188 5.85623453,18.6589532 C5.40792196,19.1164301 5.40792196,19.8362009 5.85623453,20.2936777 L8.22906755,22.6612283 C8.43444721,22.8852194 8.73110673,23.0090834 9.039287,22.9994807 C9.34458709,22.9952728 9.63581855,22.8736745 9.84950646,22.6612283 L14.3637603,18.489881 C14.8112975,18.0900203 14.8412071,17.4124367 14.4305586,16.9766468 C14.4095111,16.9538809 14.387245,16.9321939 14.3639819,16.911478 Z"
												id="Path"
												stroke={secondaryColor}
												fill={secondaryColor}
											></path>
											<path
												d="M31.961478,18.4000003 L18.638523,18.4000003 C17.998669,18.4000003 17.4800003,19.0178241 17.4800003,19.7800004 C17.4800003,20.5421767 17.998669,21.1600004 18.638523,21.1600004 L31.961478,21.1600004 C32.6013319,21.1600004 33.1200006,20.5421767 33.1200006,19.7800004 C33.1200006,19.0178241 32.6013319,18.4000003 31.961478,18.4000003 Z"
												id="Path"
												stroke={primaryColor}
												fill={primaryColor}
											></path>
											<path
												d="M14.3639819,35.3114383 C13.9298487,34.8657191 13.2091367,34.8406872 12.7434322,35.2551165 L9.03939778,38.6936603 L7.47678421,37.1152469 C7.04265104,36.6695277 6.32193901,36.6444958 5.85623453,37.0589251 C5.40792196,37.5164049 5.40792196,38.2361804 5.85623453,38.6936603 L8.22906755,41.0612264 C8.43444721,41.2852189 8.73110673,41.4090838 9.039287,41.399481 C9.34458709,41.3952731 9.63581855,41.2736741 9.84950646,41.0612264 L14.3637603,36.8898517 C14.8112975,36.4899884 14.8412071,35.8124003 14.4305586,35.3766076 C14.4095111,35.3539494 14.387245,35.3322623 14.3639819,35.3114383 Z"
												id="Path"
												stroke={secondaryColor}
												fill={secondaryColor}
											></path>
											<path
												d="M31.961478,37.7200007 L18.638523,37.7200007 C17.998669,37.7200007 17.4800003,38.3378244 17.4800003,39.1000007 C17.4800003,39.862177 17.998669,40.4800007 18.638523,40.4800007 L31.961478,40.4800007 C32.6013319,40.4800007 33.1200006,39.862177 33.1200006,39.1000007 C33.1200006,38.3378244 32.6013319,37.7200007 31.961478,37.7200007 Z"
												id="Path"
												stroke={primaryColor}
												fill={primaryColor}
											></path>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
})

ClipBoard.propTypes = {
	height: number,
	primaryColor: string,
	secondaryColor: string,
	width: number,
}
